import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllLanguages } from "../api/language";
import type { RootState } from "..";

export interface Language {
  SkillID: string;
  SkillName: string;
  SkillDesc: string;
  Count: number;
}

export interface LanguageState {
  languages: Language[];
  isLoading: boolean;
}

const initialState: LanguageState = {
  languages: [],
  isLoading: false,
};

export const getAllLanguagesAsync = createAsyncThunk(
  "language/getAllLanguages",
  async () => {
    const res: any = await getAllLanguages();
    return res.data;
  }
);

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLanguagesAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllLanguagesAsync.fulfilled, (state, action) => {
        state.languages = action.payload.Data || [];
        state.isLoading = false;
      })
      .addCase(getAllLanguagesAsync.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const selectAllLanguages = (state:  RootState ) => state.language.languages;
export const selectLanguagesLoading = (state: RootState) => state.language.isLoading;

export default languageSlice.reducer;